import React, { useEffect, useState } from "react";
import Loader from "../loader/loader";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

import barcodeIcon from '../../assets/img/icon1.svg';

import "./Dashboard.scss";

import { Grid } from "@material-ui/core";
import { useNavigate } from "react-router-dom";
import ModalPopup from "f1-modal-react";
import { ApiUrls } from "../../api/baseURL";
import { post } from "../../api/api";
import { add } from "../../offlineManager/localbase";
import useOnlineStatus from "../../useOnlineStatus";
import Alert from "@material-ui/lab/Alert";
import Snackbar from "@material-ui/core/Snackbar";
import LoaderImg from "../../assets/img/1487.gif";
import { format } from "date-fns";
import { featureHasAccess, getDateWithFormat } from "../../utils/utils";
import { metaDataConstants } from "../../utils/Constants/constants-en";

const DashBoard = (props) => {

  let navigate = useNavigate();
  const isOnline = useOnlineStatus();
  const [activateLoader, setActivateLoader] = useState(false);
  const [showModalSetup, setShowModalSetup] = useState(false);
  const [show, setShow] = useState(false);
  const moduleAccessLocal = localStorage.getItem('module_access')
  const moduleAccess = moduleAccessLocal != 'undefined' ? JSON.parse(moduleAccessLocal) : {};
  const featureAccess = JSON.parse(localStorage.getItem('feature'));

  const goToPage = (path) => {
    navigate(path);
  }
  useEffect(() => {
    const isFirstLogin = localStorage.getItem("isFirstLogin")
    if (isOnline && isFirstLogin != "false") {
      setShowModalSetup(true);
      // calling API to store data in indexed DB
      getMasterData()
    }
  }, [])

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setShow(false);

  };
  const getStorage = async () => {
    setActivateLoader(true);
    const payload = {
      "PageNumber": 1,
      "PageSize": 0
    }

    setActivateLoader(true)
    const response = await post(ApiUrls().GET_INVENTORY_STORAGE_OFFLINE, payload)
      .catch(function (error) {
        // Handle errors here
        setActivateLoader(false);
        setShow(true);
        console.error("Error:", error);
      });

    if (response?.status === 200) {
      setActivateLoader(false);
      const dataObject = {
        storageDetails: response?.data.result,
      };
      add("StorageDetails", dataObject)
        .catch((err) => console.log(err));

    } else {
      setActivateLoader(false);
    }
  };
  const getPreviousQuantity = async () => {
    setActivateLoader(true);
    const payload = {}
    setActivateLoader(true)
    const response = await post(ApiUrls().OFFLINE_PREVIOUS_QUANTITY, payload)
      .catch(function (error) {
        // Handle errors here
        setActivateLoader(false);
        setShow(true);

        console.error("Error:", error);
      });

    if (response?.status === 200) {
      setActivateLoader(false);
      const dataObject = {
        previousQuantityDetails: response?.data.result,
      };
      add("PreviousQuantityDetails", dataObject)
        .catch((err) => console.log(err));

    } else {
      setActivateLoader(false);
    }
  };
  const getDueDate = async () => {
    const payload = {
      "InventoryCheckId": 0
    };
    const response = await post(ApiUrls().OFFLINE_INVENTORY_CHECK, payload)
      .catch(function (error) {
        // Handle errors here
        setActivateLoader(false);
        setShow(true);
        console.error("Error:", error);
      });

    if (response?.status === 200) {
      const dataObject = {
        dueDateDetails: response?.data.result,
      };
      add("DueDateDetails", dataObject)
        .catch((err) => console.log(err));
    } else {
      setActivateLoader(false);
    }
  };
  const getProductStorageDeatil = async () => {

    const payload = {
    };
    // setActivateLoader(true)
    const response = await post(ApiUrls().PRODUCT_STORAGE_DETAILS_OFFLINE, payload)
      .catch(function (error) {
        // Handle errors here
        setActivateLoader(false);
        setShow(true);
        console.error("Error:", error);
      });

    if (response?.status === 200) {
      const dataObject = {
        productStorageDetails: response?.data.result,
      };
      add("ProductStorageDetails", dataObject)
        .catch((err) => console.log(err));
    } else {
      setActivateLoader(false);
    }
  };
  const getBarcodeDetails = async () => {
    const payload = {
      PageNumber: "1",
      PageSize: "10000"
    };
    let testData = []
    const response = await post(ApiUrls().SEARCH_PRODUCT_BY_UPCCODE_OFFLINE, payload)
      .catch(function (error) {
        // Handle errors here
        setActivateLoader(false);
        setShow(true);
        console.error("Error:", error);
      });

    if (response?.status === 200) {

      const count = response?.data.paging.pageCount
      testData = testData.concat(response?.data.result)

      if (response?.data.paging.totalCount > payload.PageSize) {
        for (let i = 2; i <= count + 1; i++) {
          const payload2 = {
            PageNumber: i,
            PageSize: payload.PageSize
          };
          const response = await post(ApiUrls().SEARCH_PRODUCT_BY_UPCCODE_OFFLINE, payload2)
            .catch(function (error) {
              // Handle errors here
              setActivateLoader(false);
              setShow(true);
              console.error("Error:", error);
            });
          if (response?.status === 200) {
            testData = testData.concat(response?.data.result)
          }
        }

        const dataObject = {
          barcodeDetails: testData,
        };
        localStorage.setItem("isFirstLogin", false)
        add("BarcodeDetails", dataObject)
          .catch((err) => console.log(err));
      }
      else {
        const dataObject = {
          barcodeDetails: response?.data.result,
        };
        localStorage.setItem("isFirstLogin", false)
        add("BarcodeDetails", dataObject)
          .catch((err) => console.log(err));
      }
    } else {
      setActivateLoader(false);
    }
  };
  const getAccountwiseAccountData = async () => {
    const payload = {
      IsActive: 1,
      accountId: null,
      workflowModuleKey: "INVENTORY_COUNT_FILL",
      moduleKey: 1,
      masterId: null,
      timeOffset: -330,
      isIncludePosted: 0,
      take: 1000,
      skip: 0,
      page: 1,
      pageSize: 1000,
    };
    setActivateLoader(true)

    const response = await post(ApiUrls().GET_ACCOUNTS, payload)
      .catch(function (error) {
        // Handle errors here
        setActivateLoader(false);
        setShow(true);
        console.error("Error:", error);
      });
    if (response?.status === 200) {
      const dataObject = {
        accountWiseAccountDetails: response?.data.result,
      };
      add("AccountWiseAccountDetails", dataObject)
        .catch((err) => console.log(err));
    } else {
      setActivateLoader(false);
    }
  };
  const getPhysicalInventoryCheckOffline = async () => {
    const payload = {
      "IsActive": 1,
      "accountId": "",
      "workflowModuleKey": "INVENTORY_COUNT_FILL",
      "moduleKey": 1,
      "masterId": 0,
      "timeOffset": -330,
      "isIncludePosted": 0,
      "take": 1000,
      "skip": 0,
      "page": 1,
      "pageSize": 1000
    };
    setActivateLoader(true)

    const response = await post(ApiUrls().PHYSICAL_INVENTORYCHECK_OFFLINE, payload)
      .catch(function (error) {
        // Handle errors here
        setActivateLoader(false);
        setShow(true);
        console.error("Error:", error);
      });
    if (response?.status === 200) {
      const dataObject = {
        physicalInventoryDetails: response?.data.result,
      };
      add("PhysicalInventoryDetails", dataObject)
        .catch((err) => console.log(err));
    } else {
      setActivateLoader(false);
    }
  };
  const getAccount = async () => {
    const payload = {
      UserId: localStorage.getItem("userID"),
      IsActive: 1,
    };
    setActivateLoader(true)

    const response = await post(ApiUrls().ACCOUNT_BY_CURRENT_USER, payload)
      .catch(function (error) {
        // Handle errors here
        setActivateLoader(false);
        setShow(true);
        console.error("Error:", error);
      });
    if (response?.status === 200) {
      const dataObject = {
        accountDetails: response?.data.result,
      };
      add("AccountDetails", dataObject)
        .catch((err) => console.log(err));
    } else {
      setActivateLoader(false);
    }
  };
  const getLocation = async () => {
    const payload = {
      "IsActive":1,
      "PageNumber": 1,
      "PageSize": 0
    };
    setActivateLoader(true)
    const response = await post(ApiUrls().GET_LOCATION_OFFLINE, payload)
      .catch(function (error) {
        // Handle errors here
        setActivateLoader(false);
        setShow(false);
        console.error("Error:", error);
      });

    if (response?.status === 200) {
      setActivateLoader(false);

      const dataObject = {
        locationDetails: response?.data.result,
      };
      add("LocationDetails", dataObject)
        .catch((err) => console.log(err));
    } else {
      setActivateLoader(false);
    }
  };
  const getMealPeriod = async () => {
    const payload = {
      accountId: 0,
      locationId: 0,
    }

    setActivateLoader(true)

    const response = await post(ApiUrls().SERVE_TIME_OFFLINE, payload)
      .catch(function (error) {
        // Handle errors here
        setActivateLoader(false);
        setShow(false);
        console.error("Error:", error);
      });

    if (response?.status === 200) {
      setActivateLoader(false);
      const dataObject = {
        mealPeriodDetails: response?.data.result,
      };
      add("MealPeriodDetails", dataObject)
        .catch((err) => console.log(err));
    } else {
      setActivateLoader(false);
    }
  };
  const getInmateDetails = async () => {
    const payload = {
      accountId: 0,
      orderdate: getDateWithFormat(metaDataConstants.yearMonthDateFormat)
    }
    setActivateLoader(true)
    const response = await post(ApiUrls().INMATE_DETAIL, payload)
      .catch(function (error) {
        // Handle errors here
        setActivateLoader(false);
        setShow(false);
        console.error("Error:", error);
      });

    if (response?.status === 200) {
      setActivateLoader(false);
      const dataObject = {
        allInmateDetails: response?.data.result,
      };
      add("AllInmateDetails", dataObject)
        .catch((err) => console.log(err));
    } else {
      setActivateLoader(false);
    }
  };
  const getMasterData = async () => {

    const hasAccountWiseAccess = moduleAccess.ACCOUNT_WISE_INVENTORY
    const hasLocationwiseAccess = moduleAccess.LOCATION_WISE_INVENTORY
    const hasInmateScanAccess = moduleAccess.INMATE_SCANNING

    Promise.all([
      getAccount(),  // for storing account details in location wise inventory
      hasAccountWiseAccess || hasLocationwiseAccess ? getDueDate() : null,   // for storing duedate details in location wise inventory
      getLocation(), // for storing location details in location wise inventory
      hasAccountWiseAccess || hasLocationwiseAccess ? getStorage() : null,   // for storing storage details in location wise inventory
      hasAccountWiseAccess || hasLocationwiseAccess ? getPreviousQuantity() : null,   // for storing product previous quantity  details in location wise inventory
      hasAccountWiseAccess || hasLocationwiseAccess ? getBarcodeDetails() : null,  //for storing all barcode number details  locfor both location and account wise inventory
      getAccountwiseAccountData(),  // for storing Account  details in account wise inventory
      hasAccountWiseAccess || hasLocationwiseAccess ? getPhysicalInventoryCheckOffline() : null,  // for storing product previous quantity  details in account wise inventory
      hasAccountWiseAccess || hasLocationwiseAccess ? getProductStorageDeatil() : null,  // for storing product previous quantity  details in location wise inventory  which are newly added products
      hasInmateScanAccess ? getMealPeriod() : null,
      hasInmateScanAccess ? getInmateDetails() : null,

    ]).then(() => {
      setShowModalSetup(false);
    }).catch(err => {
      console.log(err);
      setShowModalSetup(false);
    });
  }
  const getTickers = () => {
    return Object.keys(moduleAccess).map(mod => {
      featureHasAccess(mod, 'VIEW', featureAccess) && <Grid item xs={12} sm={4}>
        <div className="cardBox inventoryBarcode" onClick={() => navigate(moduleAccess[mod].path)}>
          <img src={barcodeIcon} />
          {moduleAccess[mod].displayName} <ArrowForwardIcon />
        </div>
      </Grid>
    })
  }
  return (
    <>
      <div className="container containerMainDiv">
        <Snackbar
          open={show}
          autoHideDuration={2000}
          onClose={() =>
            handleClose({ vertical: "bottom", horizontal: "right" })
          }
        >
          <Alert severity="error">{metaDataConstants.loginAgain}</Alert>
        </Snackbar>
        <ModalPopup
          className="modalDiv"
          show={showModalSetup}
          onHide={() => setShowModalSetup(!showModalSetup)}
          size={"sm"}
          centered={true}
          modelContent={
            <> <div style={{ textAlign: "center" }}><img src={LoaderImg} alt="Loader"></img></div></>}
          modelHeader={metaDataConstants.appSettingUp}
          backdrop={"static"}
        />
        <div className="contentdivBg pt-0">
          <div className="row dashboardDiv m-0">
            <div className="divRound">
              <Grid container className="MobileDiv text-center mt-5">
                <Grid item xs={12} sm={1} className="ml-5"></Grid>
              </Grid>
              <Grid container>
                {Object.keys(moduleAccess).map(mod => {
                  return featureHasAccess(mod, 'VIEW', featureAccess) && <Grid item xs={12} sm={4} key={mod}>
                    <div className="cardBox inventoryBarcode" key={mod} onClick={(a, b, c) => goToPage(moduleAccess[mod].path)}>
                      <img src={barcodeIcon} />
                      {moduleAccess[mod].displayName} <ArrowForwardIcon />
                    </div>
                  </Grid>
                })}
              </Grid>
            </div>
          </div>
        </div>
      </div>
      <Loader active={activateLoader} />
    </>
  );
};
export default DashBoard;
